<template>
  <b-card
    no-body
    class="mb-1"
  >
    <b-card-header class="p-1">
      <h5>
        Filter & Pencarian
      </h5>
    </b-card-header>
    <b-card-body>
      <b-form class="needs-validation">
        <b-row>
          <slot />
        </b-row>
      </b-form>
      <b-row>
        <b-col
          cols="12"
          class="d-flex justify-content-end"
        >
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            size="md"
            type="submit"
            @click="submitFilter"
          >
            <feather-icon
              icon="SearchIcon"
              class="mr-1"
            />
            Cari
          </b-button>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BForm,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { propsFunction } from '@/utils/propsTipeData'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BForm,
  },
  directives: {
    Ripple,
  },
  props: {
    submitFilter: propsFunction,
  },
}
</script>
